import React from "react"
import Task from "../../../../../../model2/task/task";
import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell";
import UserIconNew from "../../../../../../gd-ui/icon/user/user";


// const debug = "FieldTaskUsers_TableCell"
const debug = false


export default function FieldTaskUsers_TableCell(props: FieldTableCellProps) {

    let iconsToShow     = 5;
    if (props.column.width) {
        iconsToShow     = Math.ceil((props.column.width - 20) / 25)
    }


    let res             = [];
    let users           = _.map(props.listItem.task.users, (tu)=>gd.session.users.get(tu.userId)!)
    const task : Task   = props.listItem.task as Task;
    const companyId     = task.companyId;
    const isOpen        = gd.const.systemStatus.isOpen(props.listItem.task.systemStatus);


    const userIcon = (id:ID, actionRequired = false, assigned = false) =>
        <div key={id} className="ico">
            <UserIconNew className="user-icon" size="22" hint="up" userId={id}/>
        </div>

    if (users.length > iconsToShow) {
        // here we need to show just 2 users, rest is rest

        // first try to add AR user
        if (task.actionRequiredUserId) res.push(userIcon(task.actionRequiredUserId, true, task.assignedToUserId === task.actionRequiredUserId));

        // then assignee if not AR
        if (task.assignedToUserId && task.assignedToUserId !== task.actionRequiredUserId) res.push(userIcon(task.assignedToUserId, false, true));

        // try add created by
        if ((res.length < iconsToShow-1) && task.actionRequiredUserId !== task.createdByUserId && task.assignedToUserId !== task.createdByUserId) {
            if (task.createdByUserId) {
                res.push(userIcon(task.createdByUserId));
            }
        }

        // i.e. user who created is ar & assigned
        let moreToShow = (iconsToShow - 1) - res.length;

        if (moreToShow > 0) {
            users.map(user=>{
                if (moreToShow > 0 &&
                    user.id !== task.createdByUserId &&
                    user.id !== task.actionRequiredUserId &&
                    user.id !== task.assignedToUserId) {
                    res.push(userIcon(user.id));
                    moreToShow--;
                }
            });
        }

        const more = users.length - res.length;
        if (more > 0)
            res.push(
                <div key="more" className="ico">
                    <div className="ui5-counter circle-user">+{more}</div>
                </div>
            )

    } else {
        if (task.actionRequiredUserId && isOpen) res.push(userIcon(task.actionRequiredUserId, true));
        if (task.assignedToUserId && task.assignedToUserId !== task.actionRequiredUserId) res.push(userIcon(task.assignedToUserId, false, true));

        users.map(user=>{
            if (user.id !== task.assignedToUserId && user.id !== task.actionRequiredUserId) res.push(userIcon(user.id));
        });
    }

    return (
        <div className="cell-flex ui5-txt-less-important-small flex-row-center-center" style={getTableCellStyle(props)}>
            <div className="ui5-users-group txt-truncate">{res}</div>
        </div>
    )
}



